/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { GetOrdersApiParameter } from "@insite/client-framework/Services/OrderService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getOrdersDataView } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupProps } from "@insite/mobius/CheckboxGroup";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import ArrowRightLongIcon from "@tCentro/Icons/ArrowRightLongIcon";
import CenArrowRightIcon from "@tCentro/Icons/CenArrowRightIcon";
import { COLORS } from "@tCentro/theme/design";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
    ordersDataView?: any;
    updateTheState: (newState: boolean) => void;
    parentCheckBox: boolean;
}

type Props = OwnProps;
export interface RecentOrderListHeadingStyles {
    headingStyles?: InjectableCss;
    checkboxStyles?: CheckboxPresentationProps;
    checkboxContainer?: CheckboxGroupProps;
    allOrderLinkStyles?: LinkPresentationProps;
    leftContentStyles?: InjectableCss;
    headingMainContainer?: InjectableCss;
}

export const recentOrderListHeadingStyles: RecentOrderListHeadingStyles = {
    headingMainContainer: {
        css: css`
            justify-content: space-between;
            width: 100%;
            display: flex;
            align-items: center;
            padding: 28px 15px 15px 15px !important;
            /* border: 4px solid #f2f2f2; */
            border-bottom: none !important;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        gap: 24px;
                        align-items: flex-start;
                    `,
                    css``,
                    css``,
                    css``,
                ]);
            }}
        `,
    },
    leftContentStyles: {
        css: css`
            display: flex;
            gap: 24px;
            justify-content: flex-start;
            align-items: center;
        `,
    },
    headingStyles: {
        css: css`
            font-family: Poppins;
            font-size: 18px;
            font-weight: 600;
            line-height: 24px;
            text-align: left;
            color: ${getProp("theme.typography.p.color")};
            text-transform: uppercase;
        `,
    },
    checkboxStyles: {
        typographyProps: {
            css: css``,
        },
        iconProps: {
            size: 18,
            css: css`
                + label {
                    color: ${getProp("theme.typography.p.color")} !important;
                    font-family: Poppins;
                    font-size: 14px;
                    font-weight: 600;
                    line-height: 16px;
                }
            `,
        },
    },

    allOrderLinkStyles: {
        css: css`
            margin-left: auto;
            margin-top: 5px;
            border: 2px solid ${getColor("secondary")};
            padding: 5px 10px 5px 14px;
            flex-direction: row-reverse;
            gap: 4px;
            border-radius: 16px;
            font-family: Poppins;
            font-size: 14px;
            font-weight: 600;
            line-height: 16px;
            span:nth-child(1) {
                margin-right: 0px !important;
            }
            span:nth-child(2) {
                color: ${getColor("secondary")} !important;
            }
        `,
    },
};

const styles = recentOrderListHeadingStyles;

const CENRecentOrdersCardListHeading: React.FunctionComponent<Props> = ({
    heading,
    viewAllUrl,
    ordersDataView,
    updateTheState,
    parentCheckBox,
}) => {
    const handleCheckBox = () => {
        updateTheState(!parentCheckBox);
    };
    return (
        <StyledWrapper {...styles.headingMainContainer}>
            <StyledWrapper {...styles.leftContentStyles}>
                <StyledWrapper>
                    <Typography className="card-list-heading" {...styles.headingStyles}>
                        {heading}
                    </Typography>
                </StyledWrapper>
                {ordersDataView.value && ordersDataView.value.length > 0 && (
                    <StyledWrapper>
                        <CheckboxGroup {...styles.checkboxContainer}>
                            <Checkbox {...styles.checkboxStyles} onChange={handleCheckBox} checked={parentCheckBox}>
                                {translate("Show Open Orders Only")}
                            </Checkbox>
                        </CheckboxGroup>
                    </StyledWrapper>
                )}
            </StyledWrapper>
            {viewAllUrl && (
                <StyledWrapper>
                    <Link
                        {...styles.allOrderLinkStyles}
                        href={viewAllUrl}
                        icon={{
                            iconProps: {
                                src: CenArrowRightIcon,
                                css: css`
                                    width: 12px;
                                    height: auto;
                                    svg {
                                        > path {
                                            fill: ${getColor("secondary")};
                                        }
                                    }
                                `,
                            },
                        }}
                        typographyProps={{ size: 15 }}
                        className="view-all-link"
                        data-test-selector="cardListHeadingViewAllLink"
                    >
                        {translate("All Orders")}
                        <VisuallyHidden>
                            {translate("All Orders")} {heading}
                        </VisuallyHidden>
                    </Link>
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

export default CENRecentOrdersCardListHeading;
